import { v4 as uuidv4 } from 'uuid';

export function TabListItemChildren(props = {}, childrenComponents = []) {
	return {
		componentName: 'TabListItemChildren',
		componentId: uuidv4(),
		props: Object.assign(
			{
				label: 'Tab',
			},
			props,
		),
		childrenComponents,
	};
}
